import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() => ({
  container: {
    padding: 1,
    height: 110,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  button: {
    height: '33px',
    minHeight: '33px',
    maxHeight: '33px'
  }
}))
